<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClickTab"
        v-loading="loading"
      >
        <el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content with-tab-footer">
            <el-form
              ref="orderForm"
              :model="order"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('order.serialNo')">
                      <span v-if="order.hurry" class="red">
                        ({{ $t("order.hurrySimple") }}) </span
                      >{{ order.serialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.innerSerialNo')">
                      {{ order.innerSerialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.workflowState')">
                      <state-label
                        :state="order.workflowState"
                        :permit="Permit.canActions('orderDealView')"
                      >
                        <span v-if="Permit.canActions('orderDealView')">{{
                          $t("orderStates." + order.workflowState)
                        }}</span>
                        <span v-else>{{
                          $t("orderStatesNoPermit." + order.workflowState)
                        }}</span>
                      </state-label>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">
                      {{ order.createAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.handOverAt')">
                      {{ order.handOverAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="!Permit.isFreeEdition()">
                    <el-form-item :label="$t('order.confirmAt')">
                      {{ order.confirmAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('order.finishAt')"
                      label-width="100px"
                    >
                      {{ order.finishAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.customers')">
                      {{ order.customerName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.dealSuggest')">
                      {{ order.dealSuggest }}
                    </el-form-item>
                  </el-col>
                  <el-col v-if="bargain.settleType == 'later'" :span="8">
                    <el-form-item :label="$t('order.settlement')">
                      <span v-if="order.settlementId == null">
                        {{ $t("boolean.false") }}
                      </span>
                      <span v-if="order.settlementId != null">
                        {{ $t("boolean.true") }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("order.productInfo") }}
                  <a
                    v-if="order.attachment"
                    class="fr blue"
                    target="_blank"
                    :href="order.attachment"
                  >
                    {{ $t("action.downloadAttatchment") }}
                  </a>
                </legend>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.productNo')">
                      {{ order.productNo }}
                      <small
                        v-if="
                          order.customerProductNo != null &&
                          order.customerProductNo != ''
                        "
                      >
                        ({{ order.customerProductNo }})
                      </small>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.category')">
                      {{ order.categoryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.brand')">
                      {{ order.productBrand }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.color')">
                      <span class="float-left mgr5">{{ order.color }}</span>
                      <thumbnail
                        class="mgt5"
                        v-if="order.colorImage != null"
                        :images="order.colorImage"
                        width="25"
                        height="25"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.size')">
                      {{ order.size }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.quantity')">
                      {{ order.quantity }} {{ order.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="Permit.canActions('globalSalePrice')">
                  <el-col :span="8" v-if="order.isScore == true">
                    <el-form-item :label="$t('product.score')">
                      {{ order.score }}
                    </el-form-item>
                  </el-col>
                  <template v-else>
                    <el-col :span="8">
                      <el-form-item :label="$t('order.productPrice')">
                        <currency :code="order.currency"></currency>
                        {{ order.productPrice }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('order.price')">
                        <currency :code="order.currency"></currency>
                        {{ order.price }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('order.extraCharge')">
                        <currency
                          v-if="
                            order.extraCharge != null && order.extraCharge != 0
                          "
                          :code="order.currency"
                        ></currency>
                        {{ order.extraCharge }}
                      </el-form-item>
                    </el-col>
                  </template>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  order.specJson != null &&
                  order.specJson != '' &&
                  JSON.parse(order.specJson).length != 0
                "
                class="mgb15"
              >
                <legend>{{ $t("product.specJson") }}</legend>
                <el-tag
                  v-for="s in JSON.parse(order.specJson)"
                  :key="s.name"
                  type="info"
                  >{{ s.name }}：{{ s.value }}</el-tag
                >
              </fieldset>
              <fieldset v-if="order.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail :images="order.images" list></thumbnail>
              </fieldset>
              <fieldset
                v-if="order.remark != null && order.remark != ''"
                class="mgb15"
              >
                <legend>
                  {{ $t("text.remark") }}
                </legend>
                <raw-html :content="order.remark" type="richText" />
              </fieldset>
              <fieldset
                v-if="order.orderRemark != null && order.orderRemark != ''"
                class="mgb15"
              >
                <legend>
                  {{ $t("order.orderRemark") }}
                  <small class="orange">
                    ({{ $t("bargain.remarkExplain") }})
                  </small>
                </legend>
                <raw-html :content="order.orderRemark" />
              </fieldset>
              <fieldset v-if="order.cancelAt" class="mgb15">
                <legend>{{ $t("order.cancel") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.cancelAt')">
                      {{ order.cancelAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item :label="$t('order.cancelReason')">
                      {{ order.cancelReason }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset v-if="order.returnAt" class="mgb15">
                <legend>{{ $t("order.return") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.returnAt')">
                      {{ order.returnAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item :label="$t('order.returnReason')">{{
                      order.returnReason
                    }}</el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  Permit.canActionsChargeEdition('orderDealView') &&
                  !['confirming', 'placed', 'pending'].includes(
                    order.workflowState
                  )
                "
                class="mgb15"
              >
                <legend>{{ $t("order.dealInfo") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.dealAt')">
                      {{ order.dealAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.operatorName')">
                      {{ order.operatorName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.dealType')">
                      <span v-if="order.dealType != null">
                        {{ $t("dealTypes." + order.dealType) }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="order.dealType == 'available'">
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('order.preparedDealAt')"
                      label-width="100px"
                    >
                      {{ order.dealtAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <div v-if="order.dealType == 'purchase'">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item :label="$t('purchase.serialNo')">
                        {{ purchase.serialNo }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        :label="$t('purchase.workflowState')"
                        label-width="90px"
                      >
                        <state-label :state="purchase.workflowState">
                          {{ $t("purchaseStates." + purchase.workflowState) }}
                        </state-label>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('purchase.receiveQuantity')">
                        <span v-if="purchase.workflowState == 'finished'">
                          {{ purchase.quantity }}{{ purchase.unit }}
                        </span>
                        <span v-else>
                          {{ purchase.receiveQuantity }}{{ purchase.unit }}
                        </span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item
                        :label="$t('purchase.dealtAt')"
                        label-width="100px"
                      >
                        {{ order.dealtAt }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('menu.suppliers')">
                        {{ purchase.supplierName }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <el-row v-if="order.dealType == 'manufacture'">
                  <el-col
                    v-if="Permit.extendModels().includes('mes')"
                    :span="8"
                  >
                    <el-form-item :label="$t('order.mesWorkOrderState')">
                      <state-label :state="mesOrder.workflowState">
                        {{ $t("mesOrderStates." + mesOrder.workflowState) }}
                      </state-label>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.receiveQuantity')">
                      {{ order.receiveQuantity || 0 }}{{ order.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>

              <fieldset v-if="reworks.length != 0" class="mgb15">
                <legend>{{ $t("order.reworkInfo") }}</legend>
                <vxe-table
                  :data="reworks"
                  id="reworksTable"
                  row-id="id"
                  ref="deliverInfosTable"
                  class="recordsTable"
                  size="mini"
                  resizable
                  round
                  auto-resize
                  highlight-hover-row
                  :scroll-y="{ enabled: false }"
                >
                  <vxe-table-column
                    field="voucher"
                    :title="$t('rework.voucher')"
                  >
                    <template v-slot="{ row }">
                      <thumbnail-text :srcs="row.voucher" :text="'凭证'" />
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="quantity"
                    :title="$t('text.quantity')"
                  />
                  <vxe-table-column field="remark" :title="$t('rework.remark')">
                    <template v-slot="{ row }">
                      <raw-html-limit-number
                        :content="row.remark"
                        :number="20"
                      />
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="createAt"
                    :title="$t('text.createAt')"
                  />
                  <vxe-table-column
                    field="ownerName"
                    :title="$t('rework.ownerName')"
                  />
                  <vxe-table-column
                    field="finishAt"
                    :title="$t('rework.finishAt')"
                  />
                  <vxe-table-column
                    field="finisherName"
                    :title="$t('rework.finisherName')"
                  />
                </vxe-table>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('order.productionInfo')"
          name="track"
          v-if="order && order.dealType == 'manufacture'"
        >
          <div class="drawer-content with-tab">
            <div class="box">
              <el-row :gutter="10" v-loading="tracksLoading">
                <el-col :span="8" v-for="(t, tIndex) in tracks" :key="tIndex">
                  <div style="border: 1px dashed #999" class="mgb10">
                    <div class="mgb10 mgt5 strong center font15">
                      {{ t.woSerialNo }}
                    </div>
                    <el-timeline>
                      <el-timeline-item
                        v-for="(track, index) in t.tracks"
                        :key="index"
                        :color="track.color"
                      >
                        <div :style="'color:' + track.color">
                          {{ track.phase }}
                        </div>
                        <div
                          v-for="(d, dIndex) in track.descs"
                          :key="dIndex"
                          :style="'color:' + track.color"
                        >
                          {{ d }}
                        </div>
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('product.ingredientInfo')"
          name="material"
          v-if="
            Permit.canActionsChargeEdition('mmsProductView') &&
            order &&
            order.dealType == 'manufacture'
          "
        >
          <div class="drawer-content with-tab">
            <vxe-table
              :data="groupMaterials"
              :span-method="mergeMethod"
              id="bomsTable"
              row-id="id"
              ref="groupBomsTable"
              class="recordsTable mgb15"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              border
              :row-class-name="calculateBgColor"
              :scroll-y="{ enabled: false }"
              :loading="groupMaterialsLoading"
            >
              <vxe-table-column
                field="materialSerialNo"
                :title="$t('material.serialNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <div v-if="row.isMerge">
                    {{ row.subjectName }}
                  </div>
                  <span v-else>{{ row.materialSerialNo }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="materialName"
                :title="$t('material.name')"
                min-width="100"
              />
              <vxe-table-column
                field="color"
                :title="$t('material.color')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.color }}({{ row.colorNo }})
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('material.quantity')"
                min-width="80"
              />
            </vxe-table>
            <fieldset
              v-if="
                orderExtrainfo &&
                orderExtrainfo.remark != null &&
                orderExtrainfo.remark != ''
              "
              class="mgb15"
            >
              <legend>{{ $t("text.remark") }}</legend>
              <raw-html :content="orderExtrainfo.remark" />
            </fieldset>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="Permit.canActions('orderAsyncPdm')"
        type="defalut"
        plain
        size="small"
        @click="asyncToPdm"
        >{{ $t("order.asyncPdm") }}</el-button
      >
      <template v-if="Permit.canActions('orderManage')">
        <el-button type="defalut" plain size="small" @click="editOrderRemark">
          {{ $t("order.orderRemark") }}
        </el-button>
        <el-button
          type="success"
          size="mini"
          @click="sendMessage"
          v-if="order != null && order.follow == false"
        >
          {{ $t("action.sendMessage") }}
        </el-button>

        <el-button
          v-if="order.attachment == null && order.follow == false"
          type="defalut"
          plain
          size="small"
          @click="editAttachment"
        >
          {{ $t("text.edit") }}{{ $t("product.attachment") }}
        </el-button>
      </template>
    </div>

    <!-- 编辑结算单备注 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editOrderRemarkDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          v-model="editOrderRemarkObj.orderRemark"
          type="textarea"
          :rows="5"
        ></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editOrderRemarkSubmitDoing"
          size="small"
          @click="editOrderRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editOrderRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 发消息 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.sendMessage')"
      :close-on-click-modal="false"
      :visible.sync="sendMessageDF"
      width="40%"
    >
      <el-form
        ref="sendMessageObjForm"
        :model="sendMessageObj"
        label-width="60px"
      >
        <el-form-item
          :prop="'content'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.content')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('text.content')"
        >
          <tinymce-editor
            ref="editor"
            v-model="sendMessageObj.content"
            :height="150"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="sendMessageSubmitDoing"
          size="small"
          @click="sendMessageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="sendMessageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑附件 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('product.attachment')"
      :close-on-click-modal="false"
      :visible.sync="editAttachmentDF"
      width="40%"
    >
      <el-form
        ref="editAttachmentObjForm"
        :model="editAttachmentObj"
        label-width="60px"
      >
        <attachment v-model="editAttachmentObj.attachment" />
        <br />
        <br />
        <div>
          <small class="orange"> {{ $t("product.attachmentExplain") }}</small>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editAttachmentSubmitDoing"
          size="small"
          @click="editAttachmentSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editAttachmentDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Currency from "@/components/Currency";
import RawHtml from "@/components/RawHtml";
import ThumbnailText from "@/components/ThumbnailText";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import TinymceEditor from "@/components/TinymceEditor";
import StateLabel from "@/components/StateLabel";
import Attachment from "@/components/Attachment";

import Order from "@/api/order.js";
import OrderMes from "@/api/orderMes.js";
import Log from "@/api/log.js";
import Bargain from "@/api/bargain.js";
import Rework from "@/api/rework.js";
import Purchase from "@/api/purchase.js";
import OrderMaterial from "@/api/orderMaterial.js";
import orderExtrainfo from "@/api/orderExtrainfo.js";
import Notice from "@/api/notice.js";

export default {
  props: {
    id: Number,
    uuid: null,
    source: null,
  },
  mixins: [page],
  components: {
    Currency,
    RawHtml,
    ThumbnailText,
    Thumbnail,
    RawHtmlLimitNumber,
    StateLabel,
    TinymceEditor,
    Attachment,
  },
  data() {
    return {
      activeName: "detail",
      order: { workflowState: "newly" },
      bargain: { settleType: null },
      logs: [],
      reworks: [],
      mesOrder: { workflowState: "newly" },
      purchase: { serialNo: null, supplierName: null, workflowState: "newly" },
      //
      // 编辑结算备注
      editOrderRemarkDF: false,
      editOrderRemarkObj: {
        id: null,
        orderRemark: null,
      },
      editOrderRemarkSubmitDoing: false,
      //
      tracksLoading: false,
      tracks: [],
      //配料
      orderMaterials: [],
      groupMaterials: [],
      groupMaterialsLoading: false,
      orderExtrainfo: {
        remark: null,
      },
      //发消息
      sendMessageDF: false,
      sendMessageObj: {
        content: null,
        customerId: null,
        supplierId: null,
        type: null,
        serialNo: null,
      },
      sendMessageSubmitDoing: false,
      //编辑附件
      editAttachmentDF: false,
      editAttachmentObj: {
        uuid: null,
        attachment: null,
      },
      editAttachmentSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    editAttachment() {
      const self = this;
      self.editAttachmentObj.uuid = self.order.uuid;
      self.editAttachmentObj.attachment = null;
      self.editAttachmentSubmitDoing = false;
      self.editAttachmentDF = true;
    },
    editAttachmentSubmit() {
      const self = this;
      if (self.editAttachmentObj.attachment == null) {
        self.$message({
          message: "请上传附件",
          type: "warning",
        });
        return;
      }
      self.editAttachmentSubmitDoing = true;
      Order.updateAttachment(self.id, self.editAttachmentObj).then(function (
        res
      ) {
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
          self.getOrder();
        } else {
          slef.sysError();
        }
        self.editAttachmentSubmitDoing = false;
        self.editAttachmentDF = false;
      });
    },
    //发消息
    sendMessage() {
      const self = this;
      self.sendMessageObj.type = "sup2CusMes";
      self.sendMessageObj.customerId = self.order.customerId;
      self.sendMessageObj.serialNo = self.order.serialNo;
      self.sendMessageObj.content = null;
      self.sendMessageSubmitDoing = false;
      self.sendMessageDF = true;
    },
    sendMessageSubmit() {
      const self = this;
      self.$refs.sendMessageObjForm.validate((valid) => {
        if (valid) {
          self.sendMessageSubmitDoing = true;
          Notice.send(self.sendMessageObj).then(function (res) {
            if (res.status == 200) {
              self.sysResult(res.data);
              self.sendMessageSubmitDoing = false;
              self.sendMessageDF = false;
            } else {
              slef.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑账单备注
    editOrderRemark() {
      const self = this;
      self.editOrderRemarkObj.id = self.order.id;
      self.editOrderRemarkObj.orderRemark = self.order.orderRemark;
      self.editOrderRemarkSubmitDoing = false;
      self.editOrderRemarkDF = true;
    },
    editOrderRemarkSubmit() {
      const self = this;
      self.editOrderRemarkSubmitDoing = true;
      Order.updateOrderRemark(self.editOrderRemarkObj).then(function (res) {
        self.editOrderRemarkSubmitDoing = false;
        self.editOrderRemarkDF = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
          self.order.orderRemark = self.editOrderRemarkObj.orderRemark;
          self.$emit("updated", self.order);
        } else {
          self.sysError();
        }
      });
    },
    asyncToPdm() {
      const self = this;
      Order.asyncProductToPdm(self.id).then(function (res) {
        if (res.status == 200) {
          self.sysResult(res.data);
        } else {
          self.sysError();
        }
      });
    },
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getOrder();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
      if (this.activeName == "track") {
        this.getTracks();
      }
      if (this.activeName == "material") {
        this.getOrderMaterials();
        this.getOrderExtrainfo();
      }
    },
    getOrder() {
      const self = this;
      if (self.source == "orderCancelPendingDeals") {
        self.loading = true;
        Order.findByUuid({ uuid: self.uuid }).then(function (res) {
          if (res.data.code === 200) {
            self.order = res.data.entity;
            self.getBargain();
            self.getReworks();
            if (self.Permit.canActionsChargeEdition("orderDealView")) {
              if (self.order.dealType === "purchase") {
                self.getPurchase();
              }
              if (
                self.order.dealType === "manufacture" &&
                self.Permit.extendModels().includes("mms")
              ) {
                self.getMesOrder();
              }
            }
          } else {
            self.sysError();
          }
          self.loading = false;
        });
      } else {
        self.loading = true;
        Order.findById(self.id).then(function (res) {
          if (res.data.code === 200) {
            self.order = res.data.entity;
            self.getBargain();
            self.getReworks();
            if (self.Permit.canActionsChargeEdition("orderDealView")) {
              if (self.order.dealType === "purchase") {
                self.getPurchase();
              }
              if (
                self.order.dealType === "manufacture" &&
                self.Permit.extendModels().includes("mms")
              ) {
                self.getMesOrder();
              }
            }
          } else {
            self.sysError();
          }
          self.loading = false;
        });
      }
    },
    getMesOrder() {
      const self = this;
      OrderMes.findByUuid({ uuid: self.order.uuid }).then(function (res) {
        if (res.status === 200) {
          self.mesOrder = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getPurchase() {
      const self = this;
      Purchase.findByOrderId(self.order.id).then(function (res) {
        if (res.status === 200) {
          self.purchase = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getReworks() {
      const self = this;
      Rework.findByEntityId(self.order.id, { entity: "Order" }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.reworks = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getBargain() {
      const self = this;
      if (self.order.bargainId != null) {
        Bargain.findById(self.order.bargainId).then(function (res) {
          if (res.data.code === 200) {
            self.bargain = res.data.entity;
          } else {
            self.sysError();
          }
        });
      }
    },
    getLogs() {
      const self = this;
      Log.forEntity("Order", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
    getTracks() {
      const self = this;
      self.tracksLoading = true;
      self.tracks = [];
      Order.trackWorkInfos(self.id).then(function (res) {
        if (res.status == 200) {
          let track = res.data;
          if (track.type == "fail") {
            self.$message({
              message: track.message,
              type: "warning",
            });
          } else {
            if (track.data.length != 0) {
              for (const wo of track.data) {
                let obj = {
                  woSerialNo: wo.serialNo,
                  tracks: [],
                };
                obj.tracks.push({
                  phase: "派单",
                  color: "#67C23A",
                  descs: [wo.dispatchAt],
                });
                wo.phasePlans.forEach((pp) => {
                  let objItem = {
                    phase: pp.phaseName,
                    color: pp.phaseMake.startAt
                      ? pp.phaseMake.finishAt
                        ? "#67C23A"
                        : "#E6A23C"
                      : "",
                    descs: pp.manufactures.map((mf) => {
                      let desc = mf.quantity + wo.unit + " 开始:" + mf.startAt;
                      if (mf.endAt) {
                        desc = desc + " 结束:" + mf.endAt;
                      }
                      return desc;
                    }),
                  };
                  obj.tracks.push(objItem);
                });
                obj.tracks.push({
                  phase: "尾查",
                  color:
                    wo.qaQuantity > 0
                      ? wo.qaQuantity == wo.quantity
                        ? "#67C23A"
                        : "#E6A23C"
                      : "",
                  descs: wo.qaQuantity > 0 ? [wo.qaQuantity] : [],
                });
                obj.tracks.push({
                  phase: "出货",
                  color:
                    wo.shipQuantity > 0
                      ? wo.shipQuantity == wo.quantity
                        ? "#67C23A"
                        : "#E6A23C"
                      : "",
                  descs: wo.shipQuantity > 0 ? [wo.shipQuantity] : [],
                });
                self.tracks.push(obj);
              }
            } else {
              self.$message({
                message: "暂无跟踪信息",
                type: "warning",
              });
            }
          }
          self.tracksLoading = false;
        } else {
          self.sysError();
        }
      });
    },
    getOrderMaterials() {
      const self = this;
      if (self.order != null) {
        self.groupMaterialsLoading = true;
        OrderMaterial.findByOrderUuid({ orderUuid: self.order.uuid }).then(
          function (res) {
            if (res.status === 200) {
              self.orderMaterials = res.data;
              self.buildTableData();
              self.groupMaterialsLoading = false;
            } else {
              self.sysError();
            }
          }
        );
      }
    },
    buildTableData() {
      const self = this;
      self.groupMaterials = [];
      if (self.orderMaterials.length === 0) {
        return;
      }
      const subjectIds = self.orderMaterials.map((b) => b.subjectId);
      const subjectIdsSet = [...new Set(subjectIds)];

      for (const subjectId of subjectIdsSet) {
        const currentSubjectMaterials = self.orderMaterials.filter(
          (b) => b.subjectId == subjectId
        );
        self.groupMaterials.push({
          subjectId: subjectId,
          subjectName: currentSubjectMaterials[0].subjectName,
          isMerge: true,
          materials: currentSubjectMaterials,
        });
        for (const material of currentSubjectMaterials) {
          self.groupMaterials.push(material);
        }
      }
    },
    buildMergeCells() {
      let mcs = [];

      let colspanNumber = 5;
      if (
        (this.Permit.canActionsChargeEdition("mmsPendingRequisitionsPicking") ||
          Permit.canActionsChargeEdition(
            "mmsPendingRequisitionsPickingAndDirectFeed"
          )) &&
        this.order &&
        this.order.takeMaterialAt == null
      ) {
        colspanNumber = 5;
      } else {
        colspanNumber = 4;
      }
      for (let i = 0, rowIdx = 0; i < this.groupMaterials.length; i++) {
        mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: colspanNumber });
        if (this.groupMaterials[i].materials) {
          rowIdx = rowIdx + this.groupMaterials[i].materials.length + 1;
        }
      }
      return mcs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.buildMergeCells();
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isMerge ? "light-blue-bg" : "";
    },
    getOrderExtrainfo() {
      const self = this;
      orderExtrainfo
        .findByUuid({
          uuid: self.order.uuid,
        })
        .then(function (res) {
          if (res.data.code === 200) {
            self.orderExtrainfo = res.data.entity;
          } else {
            if (res.data.code === 404) {
              //不存在
            } else {
              self.sysError();
            }
          }
        });
    },
  },
};
</script>